module.exports = __webpack_public_path__ + "static/media/D3.7c37ae56.png";